import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import Countdown from "react-countdown";
import { useFomoCouponText } from "./useFomoCouponText.js";
import { _i } from "../utils/i18n.js";
import { localStorageTest } from "../utils/localStorageTest.js";
const LOCAL_STORAGE_NAME_PREFIX = "real-commerce-coupon-text";
/**
 * Each individual should get another text for each product and day.
 */ function useFomoCouponTextPersistence(coupon, param) {
    let { interpolateCouponInPercent, interpolateCouponString } = param;
    const lsTest = useMemo(()=>localStorageTest(), []);
    const [textParams, setTextParams] = useState([
        0,
        "-"
    ]);
    const [configuration, setConfiguration] = useState();
    const availableTexts = useFomoCouponText(textParams);
    const interpolatedComponent = useMemo(()=>{
        if (coupon && configuration) {
            const text = `${availableTexts[configuration.useTextIndex]} *`;
            return _i(text, {
                percent: interpolateCouponInPercent,
                span: interpolateCouponString,
                countdown: /*#__PURE__*/ _jsx(Countdown, {
                    className: "fomo-coupon-countdown",
                    date: new Date(coupon.validUntil),
                    // See https://git.io/JIayT
                    now: ()=>Date.now() - new Date().getTimezoneOffset() * 60 * 1000,
                    onComplete: ()=>{
                        setConfiguration(undefined);
                        setTextParams([
                            0,
                            "-"
                        ]);
                    },
                    daysInHours: true
                })
            });
        }
        return undefined;
    }, [
        coupon,
        configuration,
        availableTexts
    ]);
    useEffect(()=>{
        if (coupon) {
            const lsName = `${LOCAL_STORAGE_NAME_PREFIX}-${coupon.id}`;
            // Read from localStorage and check if still valid
            const persistedString = lsTest ? localStorage.getItem(lsName) || undefined : undefined;
            const useTextIndex = Math.floor(Math.random() * availableTexts.length);
            // E.g. localStorage is not available or expired
            const fallback = {
                created: new Date().toISOString(),
                useTextIndex
            };
            let persisted = persistedString ? JSON.parse(persistedString) : fallback;
            // We want to have a new text every day
            if (new Date(persisted.created).toDateString() !== new Date().toDateString()) {
                persisted = fallback;
            }
            // Write always back to localStorage
            if (lsTest) {
                localStorage.setItem(lsName, JSON.stringify(persisted));
            }
            const { valueInPercent, coupon: couponString } = coupon;
            setConfiguration(persisted);
            setTextParams([
                valueInPercent,
                couponString
            ]);
        } else {
            setConfiguration(undefined);
            setTextParams([
                0,
                ""
            ]);
        }
    }, [
        coupon
    ]);
    return {
        configuration,
        interpolatedComponent
    };
}
export { useFomoCouponTextPersistence };
